import { useState } from 'react';
import { tours } from '../data/data';
import './Tours.css';

// Sanitize URLs used in CSS background-image to prevent CSS injection
const safeBgUrl = (url) => {
  try {
    const u = new URL(url);
    if (u.protocol !== 'https:') return '';
    return `url("${u.href.replace(/"/g, '%22')}")`;
  } catch {
    return '';
  }
};

// const filters = ['All', 'Europe', 'Asia', 'India', 'Ocean', 'Adventure'];
const filters = ['All', 'Domestic', 'International'];

export default function Tours({ onBook }) {
  const [active, setActive] = useState('All');

  const filtered = active === 'All' ? tours : tours.filter(t => {
    const r = t.region.toLowerCase();
    // if (active === 'Europe') return r.includes('europe') || r.includes('italy') || r.includes('greece');
    if (active === 'Domestic') return r.includes('domestic');
    if (active === 'International') return r.includes('international');
    // if (active === 'Ocean') return r.includes('ocean') || r.includes('island');
    // if (active === 'Adventure') return t.type.toLowerCase().includes('adventure');
    return true;
  });

  return (
    <section id="tours" className="tours">
      <div className="container">
        <div className="tours__header">
          <div>
            <div className="eyebrow">Curated Experiences</div>
            <h2 className="section-title">Handpicked tours<br />for every soul</h2>
          </div>
          <a href="#tours" className="tours__see-all" onClick={e => { e.preventDefault(); }}>
            View all tours →
          </a>
        </div>

        <div className="tours__chips">
          {filters.map(f => (
            <button
              key={f}
              className={`tours__chip ${active === f ? 'tours__chip--active' : ''}`}
              onClick={() => setActive(f)}
            >{f}</button>
          ))}
        </div>

        <div className="tours__grid">
          {filtered.map(tour => (
            <TourCard key={tour.id} tour={tour} onBook={onBook} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TourCard({ tour, onBook }) {
  return (
    <div className="tour-card" onClick={() => onBook(tour)}>
      <div className="tour-card__img" style={{ backgroundImage: safeBgUrl(tour.img) }}>
        <div className="tour-card__img-overlay" />
        <span className={`tour-card__badge ${tour.badgeGold ? 'tour-card__badge--gold' : ''}`}>{tour.badge}</span>
        <span className="tour-card__days">{tour.days ? `${tour.days} Days` : 'Flexible'}</span>
      </div>
      <div className="tour-card__body">
        <div className="tour-card__region">{tour.region}</div>
        <div className="tour-card__name">{tour.name}</div>
        <div className="tour-card__type">{tour.type}</div>
        <div className="tour-card__footer">
          <button className="tour-card__btn" onClick={e => { e.stopPropagation(); onBook(tour); }}>
            Enquire Now
          </button>
        </div>
      </div>
    </div>
  );
}
